import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { formatDate } = useDate();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, data, payload) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 100, 30, 80 ],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(data, payload),
            styles : {
                header: {
                    fontSize: 24
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: `Overleaf of TR Challan`
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (data, payload) => {
        return [
            {
                text: `Overleaf of TR Challan`,
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${payload.start_date} - ${payload.end_date}`
                    },
                    {
                        text: `Party: ${payload.party}`
                    },
                    {
                        text: `Account Head: ${payload.account_head_name}`
                    },
                    {
                        text: `VDS Section: ${payload.vds_section}`
                    },
                    {
                        text: `TDS Section: ${payload.tds_section}`
                    },
                    {
                        text: `Payment status: ${payload.payment_status}`
                    },
                    {
                        text: `Section Type: ${payload.section_type}`
                    }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: [ 'auto', '*', 'auto','auto'],
                    body: data
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const formatTdsVdsPrintValue = (data, paymentType) => {

        let formatData = [
            getTableHead(paymentType)
        ];

        formatData = formatData.concat(getTableRow(data, paymentType));
        formatData.push(getTotals(data, paymentType));

        return formatData;
    }

    const getTableRow = (data, paymentType) => {
       return data.map((item, index) => {
            return [
                { text: index+1 },
                { text: item.client_name },
                { text: commaFormat(item.bill_amount), alignment: 'right' },
                { text: commaFormat(item[paymentType]), alignment: 'right' },
            ];
        })
    }

    const getTableHead = (paymentType) => {
        return [
            { text: 'SL NO' },
            { text: `Party NAME` },
            { text: 'Bill Amount' , alignment: 'right' },
            { text: `${ paymentType === 'tds_amount' ? 'TDS' : 'VDS'} Amount` , alignment: 'right' }
        ]
    }

    const getTotals = (data, paymentType) => {
        return [
            { text: 'Total', colSpan: 1, alignment: 'right' },
            { text: '' },
            { text: commaFormat(getTotal(data, 'bill_amount')), alignment: 'right' },
            { text: commaFormat(getTotal(data, paymentType)), alignment: 'right' },
        ];
    }

    const getTotal = (data, key) => {
      return data.reduce((sum, item) => sum + Number(item[key]), 0)
    }

    const getHeader = (company) => {
        return {
            margin: [ 30, 25, 30, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        }
    }

    const getFooter = (userName) =>{
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    return {
        exportToPDF,
        formatTdsVdsPrintValue
    }
}

export default pdfPrinter;